import { Outlet } from "react-router-dom";

const AuthRequired = ({ isLoading, isAuthenticated }) => {
  if (isLoading || !isAuthenticated) return <h1>Loading...</h1>;
  return <Outlet />;
};

export default AuthRequired;
